// src/oura/components/docs/create/CreateDocButton.tsx
//
// The doors into Create a doc on the documents board: "Create a doc" on the
// Documents card, and "Create" on a row the plan wants a doc for and none is
// made (a doc not sent yet, a code with no doc). Each renders nothing unless
// DOCS_WRITE_ON, so a build missing the write switch shows no write control.

import { FilePlus2Icon, FilesIcon } from "lucide-react";
import { DOCS_WRITE_ON } from "../../../docs/writeFlag";
import { PillButton, TAP_TARGET } from "@oura/ui";

export function CreateDocButton({ onClick }: { onClick: () => void }) {
    if (!DOCS_WRITE_ON) return null;
    return (
        <PillButton size="sm" icon={FilePlus2Icon} onClick={onClick} className={TAP_TARGET}>
            Create a doc
        </PillButton>
    );
}

/** "Create" on a row: `name` says which doc, for a screen reader. */
export function CreateRowButton({ name, onClick }: { name: string; onClick: () => void }) {
    if (!DOCS_WRITE_ON) return null;
    return (
        <PillButton size="sm" icon={FilePlus2Icon} onClick={onClick} aria-label={`Create the ${name}`} data-doc-create={name} className={TAP_TARGET}>
            Create
        </PillButton>
    );
}

/** "Convert Word files (N)": every Word file with no Google Doc yet, in one action (#4328). */
export function ConvertWordButton({ count, onClick }: { count: number; onClick: () => void }) {
    if (!DOCS_WRITE_ON) return null;
    return (
        <PillButton size="sm" icon={FilesIcon} onClick={onClick} className={TAP_TARGET}>
            Convert Word files ({count})
        </PillButton>
    );
}
